// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"545c8d29","771":"a3cecbe1"}[chunkId] + ".chunk.js";
};